module.exports = __webpack_public_path__ + "static/media/iDocBrowser-old.f72600a9.jpg";